import { shouldBootstrapEruda } from './bootstrapEruda'

const OPT_IN_KEY = '__spotty_diag_ship'

/**
 * Enable remote diagnostics for an instrumented deployment without loading Eruda.
 * Other builds retain the development, query, and localStorage opt-in gates.
 */
export function isDiagShippingEnabled(): boolean {
  if (typeof window === 'undefined') return false
  if (import.meta.env.VITE_DIAG_SHIPPING_ENABLED === '1') return true
  if (shouldBootstrapEruda()) return true
  if (new URLSearchParams(window.location?.search).has('diag')) return true
  try {
    return window.localStorage.getItem(OPT_IN_KEY) === '1'
  } catch {
    // localStorage can throw in private-mode WebViews; treat as opt-out.
    return false
  }
}
